import request from '@/utils/zsm-requets'
const fansGroup = '/role/api/interact/fansGroup/' //粉丝群相关

/**
 * 查询粉丝群分页数据
 *  @param groupName  群名称,
 *  @param groupStatus 群状态
 *  @param mobile   手机号 
 *  @returns {*}
 */
export function fansGroupListData (params) {
  return request({
    url: fansGroup + 'fansGroupListData',
    method: 'get',
    params,
    base: 'douyin'
  })
}
/**
 * 查询单条粉丝群关联课程
 *  @param id  群Id
 *  @returns {*}
 */
export function getFansGroupGood (id) {
  return request({
    url: fansGroup + 'getFansGroupGood',
    method: 'get',
    params:{id},
    base: 'douyin'
  })
}
/**
 * 删除粉丝群关联课程
 *  @param id  主键ID
 *  @returns {*}
 */
export function delFansGroupGood (id) {
  return request({
    url: fansGroup + 'delFansGroupGood',
    method: 'post',
    params:{id},
    base: 'douyin'
  })
}

/**
 * 查询粉丝群关联课程关联课程
 *  @param id  主键ID
 *  @returns {*}
 */
export function fansGroupGoodListData (params) {
  return request({
    url: fansGroup + 'fansGroupGoodListData',
    method: 'get',
    params,
    base: 'douyin'
  })
}


/**
 * 生成推广二维码
 *  @param id  主键ID
 *  @returns {*}
 */
export function createAuthQrCode (params) {
  return request({
    url: fansGroup + 'createAuthQrCode',
    method: 'post',
    params,
    base: 'douyin'
  })
}




/**
 * 绑定粉丝群关联课程关联课程
 *  @param id  主键ID
 *  @returns {*}
 */
export function addFansGroupGood (data) {
  return request({
    base: 'douyin',
    headers: {
      'Content-Type': 'application/json'
    },
    url: fansGroup + 'addFansGroupGood',
    method: 'post',
    transformRequest: [function (data) {
      data = JSON.stringify(data)
      return data
    }],
    data
  })
}



/**
 * 授权信息分页数据
 *  @param mobile   手机号 
 *  @returns {*}
 */
export function authInfoListData (params) {
  return request({
    url: fansGroup + 'authInfoListData',
    method: 'get',
    params,
    base: 'douyin'
  })
}

/**
 * 保存授权信息
 *  @param mobile   手机号 
 *  @param openId   openId 
 *  @param accessCode   授权码 
 *  @returns {*}
 */
export function saveAuthInfo (params) {
  return request({
    url: fansGroup + 'saveAuthInfo',
    method: 'get',
    params,
    base: 'douyin'
  })
}





/**
 * 创建群
 *  @param mobile   手机号 
 *  @param groupName    群名称 
 *  @param description   群介绍 
 *  @param avatarMaterial.materialUrl  头像url
 *  @param userId    授权过的用户的id 
 *  @param {Array} fansGroupGoodList   关联课程 
 *  @returns {*}
 */
export function createFansGroup (data) {
  return request({
    base: 'douyin',
    headers: {
      'Content-Type': 'application/json'
    },
    url: fansGroup + 'createFansGroup',
    method: 'post',
    transformRequest: [function (data) {
      data = JSON.stringify(data)
      return data
    }],
    data
  })
}


